import { UserTier } from './rateLimit'

export interface DeckLimits {
  maxDecks: number
  maxCardsPerDeck: number
  canCreatePrivateDeck: boolean
  canCreateCollaborativeDeck: boolean
}

export const DECK_LIMITS: Record<UserTier, DeckLimits> = {
  [UserTier.FREE]: {
    maxDecks: 1,
    maxCardsPerDeck: 5,
    canCreatePrivateDeck: false,
    canCreateCollaborativeDeck: false
  },
  [UserTier.STARTER]: {
    maxDecks: 3,
    maxCardsPerDeck: 60,
    canCreatePrivateDeck: true,
    canCreateCollaborativeDeck: false
  },
  [UserTier.ADMIN]: {
    maxDecks: -1, // unlimited
    maxCardsPerDeck: -1, // unlimited
    canCreatePrivateDeck: true,
    canCreateCollaborativeDeck: true
  }
} 